import { t } from "@/i18n-js/instance";
import { LOCATION_TYPES } from "@circle-react/components/EventsV3/Modal/utils";
import { DETAILS_SECTION_INDEX } from "@circle-react/components/LiveStreams/LiveFormV3/Modal/utils/constants";
import { useEditEventModal } from "@circle-react/components/Modals/EditEventModal";
import type { RoomType } from "@circle-react/helpers/liveStreamRoomHelpers";
import { ROOM_TYPES } from "@circle-react/helpers/liveStreamRoomHelpers";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { useAddonsContext } from "../../AddonsProvider";
import { useFormSteps } from "./hooks/useFormSteps";

interface FooterProps {
  roomType: RoomType;
  validateAndContinue: (next: () => void) => void;
}

export const Footer = ({ roomType, validateAndContinue }: FooterProps) => {
  const {
    formId,
    isSaving,
    currentStep,
    totalSteps,
    isFirstStep,
    isLastStep,
    next,
    prev,
    onExit,
  } = useFormSteps(roomType);
  const editEventModal = useEditEventModal();

  const {
    streamingHoursAvailable: isStreamingHoursAvailable,
    limitsReachedOnOpen,
  } = useAddonsContext();

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    if (roomType === ROOM_TYPES.EVENT) {
      onExit();
      void editEventModal.show({
        locationType: LOCATION_TYPES.LIVE_STREAM,
      });
    } else {
      validateAndContinue(next);
    }
  };

  const handleUpgrade = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    limitsReachedOnOpen();
  };
  return (
    <div className="flex w-full items-center justify-between">
      <Typography.TitleSm weight="semibold" color="text-light text-sm">
        {t("live_streams.form.step", { currentStep, totalSteps })}
      </Typography.TitleSm>
      <div className="flex items-center gap-3 sm:gap-5">
        {currentStep === DETAILS_SECTION_INDEX && !isStreamingHoursAvailable ? (
          <div className="flex justify-start">
            <button
              type="button"
              className="mr-1 cursor-pointer underline"
              onClick={handleUpgrade}
            >
              {t("live_streams.form.one_upgrade")}
            </button>
            <p>{t("live_streams.form.included")}</p>
          </div>
        ) : null}

        {isFirstStep && (
          <Button onClick={onExit} variant="secondary">
            {t("live_streams.form.cancel")}
          </Button>
        )}
        {!isFirstStep && (
          <Button onClick={prev} type="button" variant="secondary">
            {t("live_streams.form.prev")}
          </Button>
        )}
        {!isLastStep && (
          <Button
            onClick={handleNextButtonClick}
            type="button"
            variant="circle"
            className="border-darkest border"
          >
            {t("live_streams.form.next")}
          </Button>
        )}
        {isLastStep && (
          <Button
            form={formId}
            disabled={isSaving}
            type="submit"
            variant="circle"
            className="border-darkest border"
          >
            {t("live_streams.form.submit_button_label")}
          </Button>
        )}
      </div>
    </div>
  );
};
